module.exports = __webpack_public_path__ + "img/logo_cvut.7bd7e14b.jpg";